import { ChannelSubscriberStatModel } from '../shared/models/channel-subscriber-stat-model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'hr-stats-and-reports-subscribers',
  templateUrl: './stats-and-reports-subscribers.component.html',
  styleUrls: ['./stats-and-reports-subscribers.component.less'],
  standalone: false,
})
export class StatsAndReportsSubscribersComponent implements OnInit {
  @Input()
  public channelSubscriberStats: ChannelSubscriberStatModel[];
  constructor() {}

  ngOnInit() {}
}
